import { List, Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticCurrencyLookup from '../../../Common/Models/StaticCurrencyLookup';
import UpdateOrganisationCommand from '../Models/Commands/UpdateOrganisationCommand';
import OrganisationLookup from '../Models/Lookups/OrganisationLookup';
import { StaticDataTypes } from '../../StaticData/StaticDataTypes';

@NeoModel
export default class ManageOrganisationComponentVM extends Views.ViewModelBase {

    public manageOrganisation = new UpdateOrganisationCommand();

    constructor(
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache),
        public organisationApiClient = AppService.get(Types.ApiClients.GeneralApiClient))
    {
        super(taskRunner);
    }

    public OrganisationList = new List(OrganisationLookup);
    public CurrencyDataList: Model.PlainObject<StaticCurrencyLookup>[] = [];
    public CurrencyId: number = 0;
    public isFieldReadOnlyInd: boolean = true;

    public async initialise() {
        await this.loadOrganisationList();
    }

    public async loadOrganisationList() {
       const response = await this.taskRunner.waitFor(this.organisationApiClient.getStaticOrganisationList());
       this.OrganisationList.set(response.data);
       this.CurrencyDataList = await this.staticDataCache.staticCurrencies.getDataAsync();
    }

    public validateSourceFieldValue() {
        this.manageOrganisation.nominatedCurrencyId = this.CurrencyId;
    }
}